import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SignInComponent } from './sign-in.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ModalModule } from 'src/app/components';

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule, ModalModule],
  exports: [SignInComponent],
  declarations: [SignInComponent],
  providers: []
})
export class SignInModule {}
